/*
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2022-03-11 14:30:38
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-03-01 09:44:53
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/WeMeet_admin_project/wemeet-admin/src/views/dragger/template/index.js
 * @Description:
 * Copyright (c) 2023 by WeMeet, All Rights Reserved.
 */
import tpl_banner from './tpl-banner' //轮播图
import tpl_grid from './tpl-grid' // 宫格导航
import tpl_search from './tpl-search' // 搜索栏
import tpl_publish from './tpl-publish' // 搜索栏
import tpl_title from './tpl-title' // 标题栏
import tpl_tab from './tpl-tab' // tab栏
import tpl_view_list from './tpl-view-list' // 广告魔方
import tpl_link from './tpl_link' // 超链接

// 广告魔方 排版布局
import tpl_left_one_right_two from './tpl_left_one_right_two'
import tpl_left_one_right_one from './tpl_left_one_right_one'
import tpl_left_two_right_one from './tpl_left_two_right_one'
import tpl_flex_three from './tpl_flex_three'
import tpl_flex_one from './tpl_flex_one'
import tpl_flex_two from './tpl_flex_two'
import tpl_top_one_bottom_two from './tpl_top_one_bottom_two'
import tpl_top_two_bottom_one from './tpl_top_two_bottom_one'
import tpl_flex_five from './tpl_flex_five'
import tpl_flex_four from './tpl_flex_four'
import tpl_text_picture from './tpl_text_picture'
import tpl_richText from './tpl_richText'
export default {
  carousel: tpl_banner,
  grid: tpl_grid,
  search: tpl_search,
  publish: tpl_publish,
  title: tpl_title,
  tab: tpl_tab,
  advertise: tpl_view_list,
  link: tpl_link,

  // 排版布局
  leftOneRightTwo: tpl_left_one_right_two,
  leftOneRightOne: tpl_left_one_right_one,
  leftTwoRightOne: tpl_left_two_right_one,
  flexThree: tpl_flex_three,
  flexOne: tpl_flex_one,
  flexTwo: tpl_flex_two,
  topOneBottomTwo: tpl_top_one_bottom_two,
  topTwoBottomOne: tpl_top_two_bottom_one,

  flexFive: tpl_flex_five,
  flexFour: tpl_flex_four,
  textPicture: tpl_text_picture,
  richText: tpl_richText,
}
